
/** 机构排名信息 */
export const ORGAN_RANK = 'organ_rank_info'